import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { timeout, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(
    private http: HttpClient
  ) { }

  private executeFilter = new Subject<void>();
  executeFilter$ = this.executeFilter.asObservable();

  executeFilterFunction(): void {
    this.executeFilter.next()
  }

  getWelcomeContent(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/v2/public/welcome-content`);
  }

  dataURLtoFile(dataurl, filename) { 
    if(dataurl){
      var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
    }
    return new File([u8arr], filename, {type:mime});
  }

  formatGETId(membershipKey = 0, userId = 0) {

    const padLeft = (numb: number, size: number) => {
      let s = numb + '';
      while (s.length < size) { s = '0' + s; }
      return s;
    }

    const a = padLeft(membershipKey, 4);
    const formatedUserId = padLeft(userId, 8);

    const b = formatedUserId.substring(0, 4);
    const c = formatedUserId.substring(4, 8);

    return a + '-' + b + '-' + c;

  }

  getUnreadNotification(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/v2/account/user-notifications');
  }

  readNotification(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/account/read-notification', JSON.stringify(item));
  }

  getEventsList(){
    return this.http
    .post<any>(environment.apiUrl + '/api/rider/appointments', '');
  }
}
